import { Button, Table, TablePagination, TablePropertyFiltering, TableSorting } from 'AWS-UI-Components-React';
import React from 'react';
import { V2_PROPERTY_FILTERING_TEXT } from '../../common/property_filter_helpers';
import { COMPONENT_NAMES } from '../../../constants/asin_metric_elements';
import { downloadFile, extractErrorMessage, toDownloadFormat } from '../../../utilities';
import { formatTimeFrameToYYYYMM, YYYYMMDDToFormattedDate } from '../../../utils/date-utils';
import { EmptyMessage } from '../../content/empty_message';
import { OPERATION_STATUS, TEXT } from '../common/constants';
import { getAsinMetricsFilteringOptions, getColumnDefinitions } from './asin_metrics_utils';
import logger from '../../../utils/logging';

const ASIN_TABLE_PAGE_SIZE = 20;

export class GlMetricTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      downloadStatus: OPERATION_STATUS.NONE,
      isAsinMetric: this.props.tableName === 'ASIN Metrics',
    };
  }

  onDownloadData = () => {
    const {items, displayInMillions, payload, latestSnapshot, tableName} = this.props;
    this.setState({ downloadStatus: OPERATION_STATUS.IN_PROGRESS });
    const month = formatTimeFrameToYYYYMM(payload.timeFrame);
    try {
      const formattedItems
        = items.map(item => ({...item, component: COMPONENT_NAMES[item.component] || item.component }));
      const data = toDownloadFormat(getColumnDefinitions(items, displayInMillions), formattedItems);
      downloadFile(data, `${tableName}_${month}_As_of_${YYYYMMDDToFormattedDate(latestSnapshot)}.xls`);
      this.setState({ downloadStatus: OPERATION_STATUS.SUCESS });
    } catch (error) {
      logger.error(extractErrorMessage(error), error);
      this.setState({downloadStatus: OPERATION_STATUS.FAIL});
    }
  };

  render() {
    const {tableName, glInfo, shipMonthInfo, items, loading, displayInMillions, downloadEnabled} = this.props;
    const empty = !items || !items.length;
    const columnDefinitions = getColumnDefinitions(items, displayInMillions, this.state.isAsinMetric);
    const sortableColumns = [
      { id: "NET_FA", field: "NET_FA" },
      { id: "NET_LA", field: "NET_LA" },
      { id: "NET_VAR_PER_UNIT", field: "NET_VAR_PER_UNIT" },
      { id: "ABS_VAR_PER_UNIT", field: "ABS_VAR_PER_UNIT" },
      { id: "WINSORIZED_NET_VAR_PER_UNIT", field: "WINSORIZED_NET_VAR_PER_UNIT" },
      { id: "WINSORIZED_ABS_VAR_PER_UNIT", field: "WINSORIZED_ABS_VAR_PER_UNIT" }];

    return (
      <div style={{marginTop: '1.5em'}}>
        <Table
          className="ZebraStripesTable accuracy-table-container"
          columnDefinitions={columnDefinitions}
          items={items}
          loadingText={TEXT.LOADING}
          loading={loading}
          wrapLines={false}
          empty={<EmptyMessage />}
          header={
            <div className="awsui-util-action-stripe">
              <div className="awsui-util-action-stripe-title">
                <h4>{tableName}</h4>
                <p>{glInfo}</p>
                <p>{shipMonthInfo}</p>
              </div>
              { downloadEnabled &&
              <div className="awsui-util-action-stripe-group">
                <Button
                  text="Download"
                  variant="normal"
                  onClick={this.onDownloadData}
                  disabled={loading || empty}
                  loading={this.state.downloadStatus === OPERATION_STATUS.IN_PROGRESS}
                  data-cy="asin-all-components-download"
                />
              </div>
              }
            </div>
          }>
          <TableSorting sortingDescending={true}
                        sortableColumns={sortableColumns} />
          <TablePropertyFiltering
            filteringOptions={getAsinMetricsFilteringOptions(items, columnDefinitions)}
            {...V2_PROPERTY_FILTERING_TEXT}
            placeholder={`Filter ${tableName} by property or value`}
          />
          {!empty && items.length > ASIN_TABLE_PAGE_SIZE &&
            <TablePagination pageSize={ASIN_TABLE_PAGE_SIZE} />}
        </Table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/reports/asin_metrics/gl_metric_table.jsx